import { render, staticRenderFns } from "./ClinicsAvailability.vue?vue&type=template&id=629da9c4&"
import script from "./ClinicsAvailability.vue?vue&type=script&lang=js&"
export * from "./ClinicsAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports